"use client";

import { useLocale } from "@i18n/react";
import { useQueryClient } from "@tanstack/react-query";

import type { FamilyInvite } from "../../../lib/types/schema/subscription/familySchema";
import { useOpenApiMutation } from "../../../request/hooks/openApi/useOpenApiMutation";
import { useRequestMutation } from "../../../request/hooks/useRequestMutation";
import { keySubscription } from "./keySubscriptions";

export const useRequestMutationsFamily = () => {
  const queryClient = useQueryClient();
  const locale = useLocale();

  return {
    // POST /family/users
    mutationAddMember: useOpenApiMutation({
      method: "POST",
      urlBackendPath: "/family/users",
    }),

    // DELETE /family/users/{id}
    mutationRemoveMember: useOpenApiMutation({
      method: "DELETE",
      urlBackendPath: "/family/users/{id}",
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [keySubscription(), locale],
        });
      },
    }),

    // DELETE /family/invites/{id} - NOT in OpenAPI spec, keep old approach
    mutationCancelInvite: useRequestMutation({
      mutationFnRequestProps: ({ id }: Pick<FamilyInvite, "id">) => ({
        urlBackendPath: `/family/invites/${id}`,
        method: "DELETE",
      }),
    }),

    // POST /families/{code}/users
    mutationJoin: useOpenApiMutation({
      method: "POST",
      urlBackendPath: "/families/{code}/users",
    }),
  };
};
